'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { CheckMarkCircle, FilterIcon, TrashIcon } from '@insta-club/components';
import { useBoolean, useCustomForm } from '@insta-club/hooks';
import { PostType } from '@insta-club/models';
import { BottomSheet, Button, Form, Select } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import { ExploreFilterFormValues, ExploreFilterSchema } from '@insta-club/validator';
import { SubmitHandler } from 'react-hook-form';
import { ExploreFilterType, ExploreFilterTypeResponse, VideoStyle } from 'src/libs/models/explore.model';
import useSWR from 'swr';

function ExploreFilter() {
    const filterSheet = useBoolean(false);
    const form = useCustomForm(ExploreFilterSchema);

    const onSubmit: SubmitHandler<ExploreFilterFormValues> = async (data) => {
        try {
            console.log(data, 'filter data');
        } catch (error) {
            console.error(error);
        }
    };

    const { data: filters, isLoading: filtersLoading } = useSWR<ExploreFilterTypeResponse>(
        ApiKeys.GET_REELS_FILTERS,
        (url: string) => fetcher(url, 'dashboard', 'GET')
    );

    const {
        data: postTypes
        // isLoading: postTypesLoading
    } = useSWR<PostType[]>(ApiKeys.GET_POST_TYPE, (url: string) => fetcher(url, 'dashboard', 'GET'));

    const {
        data: videoStyle
        // isLoading: videoStyleLoading
    } = useSWR<VideoStyle[]>(ApiKeys.GET_POST_TYPE, (url: string) => fetcher(url, 'dashboard', 'GET'));

    return (
        <>
            <button
                type='button'
                onClick={() => filterSheet.onTrue()}
                aria-label='filter'
                className='bg-primary-500 fixed end-6 bottom-[110px] z-10 cursor-pointer rounded-2xl p-4 text-white shadow-md sm:absolute'
            >
                <FilterIcon />
            </button>

            <BottomSheet open={filterSheet.value} onClose={filterSheet.onFalse} title='فیلتر کردن'>
                <Form form={form} onSubmit={onSubmit}>
                    <div className='space-y-6'>
                        <div className='space-y-6'>
                            <Select
                                isSearchable
                                name='post_type'
                                label='نوع پست'
                                options={
                                    postTypes?.map((item: PostType) => {
                                        return { label: item.full_name, value: item.id };
                                    }) ?? []
                                }
                            />
                            <Select
                                isSearchable
                                name='video_style'
                                label='سبک ویدیو'
                                options={
                                    videoStyle?.map((item: VideoStyle) => {
                                        return { label: item.full_name, value: item.id };
                                    }) ?? []
                                }
                            />
                        </div>

                        <div className='flex items-center space-x-3'>
                            {!filtersLoading &&
                                filters?.data.length &&
                                filters?.data?.map((item: ExploreFilterType) => {
                                    return (
                                        <div
                                            key={item.name}
                                            className={cn(
                                                'flex cursor-pointer items-center space-x-1 rounded-lg border border-gray-300 bg-gray-100 px-2 py-1',
                                                {
                                                    'border-primary-500 bg-primary-500': false
                                                }
                                            )}
                                        >
                                            {false && <CheckMarkCircle />}
                                            <span
                                                className={cn('text-sm font-normal text-gray-700', {
                                                    'text-white': false
                                                })}
                                            >
                                                {item.name}
                                            </span>
                                        </div>
                                    );
                                })}
                        </div>

                        <div className='flex flex-col items-center gap-2.5 lg:flex-row'>
                            <Button size='lg' className='w-full lg:w-2/3!'>
                                مشاهده نتایج
                            </Button>
                            <Button variant='text' color='danger' size='lg' className='w-full lg:w-1/3'>
                                <TrashIcon className='ml-2' />
                                حذف فیلتر
                            </Button>
                        </div>
                    </div>
                </Form>
            </BottomSheet>
        </>
    );
}

export default ExploreFilter;

